import _ from 'lodash'

const historyStack = 'HISTORY_STACK'
const firstPage = 'FIRST_PAGE'

export const getLocalConfig = name => {
    // if
    try {
        return JSON.parse(localStorage.getItem(name)) || ''
    } catch (err) {
        return ''
    }
}

export const setLocalConfig = (name, config) => {
    try {
        localStorage.setItem(name, JSON.stringify(config))
    } catch (err) {
        localStorage.setItem(name, '')
    }
}

export const removeLocalConfig = name => {
    try {
        localStorage.removeItem(name)
    } catch (err) {
        localStorage.removeItem(name)
    }
}

/**
 * 清空访问第一个path
 */
export const removeFirstPage = path => {
    localStorage.removeItem(firstPage)
}
/**
 * 记录访问的第一个Path 到sessionStorage，便于授权登录成功返回
 */
export const setFirstPage = path => {
    localStorage.setItem(firstPage, JSON.stringify(path))
}
/**
 * 返回访问的第一个Path 到sessionStorage，便于授权登录成功返回
 */
export const getFirstPage = () => {
    // if (checkStorage().valid) {
    try {
        let page = JSON.parse(localStorage.getItem(firstPage))
        if (page.path === '/login' || !page || _.isEmpty(page)) {
            page = { path: '/' }
        }
        return page
    } catch (err) {
        return { path: '/' }
    }
    // } else {
    //     window['firstPage'] =
    // }
}
/**
 * 将历史记录栈保存到 sessionStorage，以便用户刷新之后，程序能够得知历史记录信息
 * @param stacks 历史记录栈
 */
export const setHistoryStack = (stacks = []) => {
    const resolvedStacks = _.map(stacks, route => {
        return _.pick(route, ['name', 'meta', 'path', 'hash', 'fullPath'])
    })

    sessionStorage.setItem(historyStack, JSON.stringify(resolvedStacks))
}

/**
 * 尝试用 sessionStorage 获取历史记录信息
 */
export const getHistoryStack = () => {
    return JSON.parse(sessionStorage.getItem(historyStack) || '[]')
}
